import * as constants from "./../constants";
import { Query, Config, SortDirection, KeyValue } from "../../interfaces";
import { buildQueryUrl, buildCsvDowloadUrl } from "../services/ApiClient";

export interface UpdateFilterAction {
  type: constants.UPDATE_FILTER;
  filterField: string;
  filterValue: string | string[] | number | number[] | undefined;
}

export interface UpdateRouterAction {
  type: constants.UPDATE_ROUTER;
  routerField: string;
  routerValue: string[] | KeyValue[];
}

export interface UpdateSearchAction {
  type: constants.UPDATE_SEARCH;
  searchField: string;
  searchValue: string;
}

export interface UpdateUiAction {
  type: constants.UPDATE_UI;
  uiField: string;
  uiValue:
    | string
    | string[]
    | number
    | boolean
    | KeyValue
    | KeyValue[]
    | undefined;
}

export interface UpdatePaginationAction {
  type: constants.UPDATE_PAGINATION;
  paginationField: string;
  paginationValue: number;
}

export function setFilterValue(
  filterField: string,
  filterValue: string | string[] | number | number[] | undefined,
): UpdateFilterAction {
  return {
    type: constants.UPDATE_FILTER,
    filterField,
    filterValue,
  };
}

export function setRouterValue(
  routerField: string,
  routerValue: string[] | KeyValue[],
): UpdateRouterAction {
  return {
    type: constants.UPDATE_ROUTER,
    routerField,
    routerValue,
  };
}

export function setSearchValue(
  searchField: string,
  searchValue: string,
): UpdateSearchAction {
  return {
    type: constants.UPDATE_SEARCH,
    searchField,
    searchValue,
  };
}

export function setUiValue(
  uiField: string,
  uiValue:
    | string
    | string[]
    | number
    | boolean
    | KeyValue
    | KeyValue[]
    | undefined,
): UpdateUiAction {
  return {
    type: constants.UPDATE_UI,
    uiField,
    uiValue,
  };
}

export function setPaginationValue(
  paginationField: string,
  paginationValue: number,
): UpdatePaginationAction {
  return {
    type: constants.UPDATE_PAGINATION,
    paginationField,
    paginationValue,
  };
}

export interface ResetStateAction {
  type: constants.RESET_STATE;
  newState: Query;
}
export function resetState(newState: Query): ResetStateAction {
  return {
    type: constants.RESET_STATE,
    newState,
  };
}

export interface UpdateSortOrderAction {
  type: constants.UPDATE_SORT;
  newSortField: string;
  newSortOrder: SortDirection;
}
export function setSortOrder(
  newSortField: string,
  newSortOrder: SortDirection,
): UpdateSortOrderAction {
  return {
    type: constants.UPDATE_SORT,
    newSortField,
    newSortOrder,
  };
}
export interface AddValuesAction {
  type: constants.ADD_VALUE;
  newValues: string[] | number[];
  filterField?: string;
}
export function addValue(
  newValues: string[] | number[],
  filterField?: string,
): AddValuesAction {
  return {
    type: constants.ADD_VALUE,
    newValues: newValues,
    filterField,
  };
}

export interface RemoveValueAction {
  type: constants.REMOVE_VALUE;
  removedFields: string[] | number[];
  filterField?: string;
}
export function removeValue(
  removedFields: string[] | number[],
  filterField?: string,
): RemoveValueAction {
  return {
    type: constants.REMOVE_VALUE,
    removedFields,
    filterField,
  };
}

export interface UpdateDisplayFieldAction {
  type: constants.UPDATE_DISPLAY_FIELDS;
  displayfields: string[];
}
export function setDisplayFields(
  displayfields: string[],
): UpdateDisplayFieldAction {
  return {
    type: constants.UPDATE_DISPLAY_FIELDS,
    displayfields,
  };
}

export interface UpdateApiUrlsAction {
  type: constants.UPDATE_API_URLS;
  apiJson: Query["urls"]["apiJson"];
  csvDownload: Query["urls"]["csvDownload"];
}
export function setApiUrls(
  query: Query,
  apiPath: Config["apiPath"],
): UpdateApiUrlsAction {
  return {
    type: constants.UPDATE_API_URLS,
    apiJson: buildQueryUrl(apiPath, query),
    csvDownload: buildCsvDowloadUrl(apiPath, query),
  };
}

export interface ReadBrowserLocationAction {
  type: constants.READ_BROWSER_LOCATION_INTO_STATE;
}
export function readBrowserLocation(): ReadBrowserLocationAction {
  return {
    type: constants.READ_BROWSER_LOCATION_INTO_STATE,
  };
}

export interface SaveBrowserLocationAction {
  type: constants.SAVE_BROWSER_LOCATION_INTO_STATE;
  appPath: string;
  apiPath: string;
}
export function saveBrowserLocation(
  appPath: string,
): SaveBrowserLocationAction {
  return {
    type: constants.SAVE_BROWSER_LOCATION_INTO_STATE,
    appPath,
    apiPath: constants.apiPathLookup[appPath],
  };
}

export interface UpdateBrowserLocationAction {
  type: constants.UPDATE_BROWSER_LOCATION;
  locationSearchString: string;
}
export function setBrowserLocation(
  locationSearchString: string,
): UpdateBrowserLocationAction {
  return {
    type: constants.UPDATE_BROWSER_LOCATION,
    locationSearchString,
  };
}
export interface UpdateAppAction {
  type: constants.UPDATE_APP;
  app: string;
}
export interface UpdateUUIDAction {
  type: constants.UPDATE_UUID;
  uuid: string;
}

export function updateApp(app: string): UpdateAppAction {
  return {
    type: constants.UPDATE_APP,
    app,
  };
}
export function updateUUID(uuid: string): UpdateUUIDAction {
  return {
    type: constants.UPDATE_UUID,
    uuid,
  };
}
export interface UpdateAggAction {
  type: constants.UPDATE_AGG;
  aggBy: string;
  aggTermFields: string[];
  aggSumFields?: string[];
  subTotalBy?: string;
  totalFields?: string[];
}

export function updateAgg(
  aggBy: string,
  aggTermFields: string[],
  aggSumFields?: string[],
  subTotalBy?: string,
  totalFields?: string[],
): UpdateAggAction {
  return {
    type: constants.UPDATE_AGG,
    aggBy,
    aggTermFields,
    aggSumFields,
    subTotalBy,
    totalFields,
  };
}

export interface UpdateBannerAction {
  type: constants.UPDATE_BANNER;
  banner: string;
}

export function updateBanner(banner: string): UpdateBannerAction {
  return {
    type: constants.UPDATE_BANNER,
    banner,
  };
}
